module.exports = __webpack_public_path__ + "assets/9e400f95770d692e6cf001f45f0f51b2.png";